// Codes des messages a afficher dans la status bar (correspond au C_MESSAGE stocke en base)
const DETAIL = "LoadingDetail"; // Chargement des details
const SEARCHING = "Searching"; // Recherche en cours
const CANCELING = "Canceling"; // annulation en cours
const VALIDATING = "Validating"; // Validation en cours
const DELETING = "Deleting"; // suppression en cours
const LOADING = "Loading"; // Chargement en cours
const WAITING = "Waiting"; // Chargement en cours
const WAITING_FAM = "STATUSBAR";
// TGUE - 27/02/2009 - [DEV20259] traitement en cours
const TREATING = "Treating"; // traitmement en cours

window.DETAIL = DETAIL;
window.SEARCHING = SEARCHING;
window.CANCELING = CANCELING;
window.VALIDATING = VALIDATING;
window.DELETING = DELETING;
window.LOADING = LOADING;
window.WAITING = WAITING;
window.WAITING_FAM = WAITING_FAM;
window.TREATING = TREATING;
